require('./marketPulseNews.scss')

const PropTypes = require('prop-types');

const React = require('react');

const StorySummary = require('./brokerStorySummary');
const { OKLink } = require('commonsComponents/OKLink');
const { DATE_FORMAT_ES } = require('constants/index');
const DateHelper = require('utilities/dateHelper');

const { LoadingSection } = require('commonsComponents/loadingSection');

class MarketPulseNews extends React.Component {
    componentDidMount() {
        this.props.requestMarketPulses({
            start: 0,
            end: 3
        });
    }

    buildPulseContent() {
        const {
            immMarketsPulses,
            newsSection,
            pageName
        } = this.props;
        const pulseData = immMarketsPulses.get('byOrder');
        const stories = pulseData.map((pulseId, index) => {
            const immPulse = immMarketsPulses.getIn(['byId', pulseId]);
            const parsedDate = `${DateHelper.buildFormattedDate(immPulse.get('date'), DATE_FORMAT_ES)} - ${immPulse.get('date').split(' ').pop().slice(0, -3)}`;
            const objId = `broker-news-pulse-${index}`;
            return (
                <OKLink modifier="emphasize" key={objId} className="broker-news-market-pulse" to={`/myprofile/broker/pulses/${immPulse.get('id')}`} tabIndex="-1">
                    <StorySummary
                        myDate={parsedDate}
                        title={immPulse.get('title')}
                        summary=""
                        readMore={false}
                        colorTitle="blue"
                        newsSection={newsSection}
                        pageName={pageName}

                    />
                </OKLink>
            );
        });

        return stories;
    }

    render() {
        const {
            immMarketsPulses
        } = this.props;

        if ( immMarketsPulses.get('isFetching') ) {
            return (<LoadingSection />);
        }

        if ( immMarketsPulses.get('error') ) {
            return (<p>Ha ocurrido un error</p>);
        }

        const pulseMarket = this.buildPulseContent();

        return (
            <div>
                {pulseMarket}
            </div>
        );
    }
}

MarketPulseNews.propTypes = {
    immMarketsPulses: PropTypes.object.isRequired,
    requestMarketPulses: PropTypes.func.isRequired,
    newsSection: PropTypes.bool.isRequired,
    pageName: PropTypes.string
}

module.exports = MarketPulseNews;